import * as React from 'react';

import ArrowDown from 'assets/icons/arrows/arrow-down-16.svg';
import SwapIcon from 'assets/icons/arrows/arrows-circle-16.svg';
import SettingsIcon from 'assets/icons/nav/icon-settings-16.svg';
import Info from 'assets/icons/status/icon-info-16.svg';

import { Container as AssetPicker } from 'basics/asset-pickers/AssetPicker.layout';
import { Form } from 'basics/form/Form';
import {
    AmountContainer,
    AmountLabel,
    Balance,
    BalanceLabel,
    BalanceValue,
    Container as Field,
    PercentSpacer,
    PickerContainer,
} from 'basics/form/TokenAmountFormField.layout';
import BlankInput from 'basics/inputs/BlankInput';
import { DotsLoader } from 'basics/loaders';
import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { Container as UsdEquivalent } from './AmountUsdEquivalent/AmountUsdEquivalent.styled';
import useSwapAccountLayout from './hooks/useSwapAccountLayout';
import PercentButtons from './PercentButtons/PercentButtons';
import { SettingsButton, StyledButton, SwapHeader, SwapRows } from './SwapForm.styled';
import { Container as Divider, RevertButton } from './SwapFormDivider/SwapFormDivider.styled';

const SwapFormLoading = ({ embedded = false }: { embedded?: boolean }) => {
    const reserveAccountSpace = useSwapAccountLayout();

    return (
        <Form as="div" $isEmbedded={embedded} aria-hidden="true" data-testid="swap-form">
            {embedded ? (
                <SwapHeader>
                    <h3>Swap assets</h3>
                    <div>
                        <SettingsIcon />
                    </div>
                </SwapHeader>
            ) : (
                <SettingsButton as="span">
                    <SettingsIcon />
                </SettingsButton>
            )}
            <SwapRows>
                {[true, false].map(sell => (
                    <Field key={String(sell)} $isEmbedded={embedded} $disabled={false}>
                        <AmountContainer>
                            <AmountLabel>{sell ? 'Sell' : 'Buy'}</AmountLabel>
                            <BlankInput placeholder="0" readOnly tabIndex={-1} />
                            <UsdEquivalent>
                                <span>$0</span>
                            </UsdEquivalent>
                        </AmountContainer>
                        <PickerContainer>
                            {sell ? (
                                reserveAccountSpace && (
                                    <PercentButtons pending setPercent={() => undefined} />
                                )
                            ) : (
                                <PercentSpacer />
                            )}
                            <AssetPicker $disabled>
                                <Bar $width="3.2rem" $height="3.2rem" $circle />
                                <Bar $width="4rem" />
                                <ArrowDown />
                            </AssetPicker>
                            {reserveAccountSpace && (
                                <Balance>
                                    <BalanceValue>
                                        <BalanceLabel>
                                            {sell ? 'Available: ' : 'Balance: '}
                                        </BalanceLabel>
                                        <DotsLoader />
                                    </BalanceValue>
                                    {sell && <Info />}
                                </Balance>
                            )}
                        </PickerContainer>
                    </Field>
                ))}
                <Divider>
                    <RevertButton>
                        <SwapIcon />
                    </RevertButton>
                </Divider>
            </SwapRows>
            <StyledButton isBig isRounded fullWidth disabled tabIndex={-1}>
                {reserveAccountSpace ? 'Enter amount' : 'Connect wallet'}
            </StyledButton>
        </Form>
    );
};

export default SwapFormLoading;
